export default "__VITE_ASSET__23a2f035__"